import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mat',
  templateUrl: './mat.component.html'
  , styleUrls: ['./mat.component.scss']
})
export class MatComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
